/** @format */

import angular from 'angular';
import angularUiRouter from 'angular-ui-router';
import angularMaterial from 'angular-material';
import angularMessages from 'angular-messages';

import 'angular-material/angular-material.min.css';
import 'material-design-icons/iconfont/material-icons.css';
import 'angular-material-data-table/dist/md-data-table.css';

import './scss/shared.scss';

import { CacheModule } from 'crowdcomms-js/lib/cache';
import { GalabidUrlModule } from 'crowdcomms-js/lib/galabid/galabid-url';
import { PusherModule } from 'crowdcomms-js/lib/realtime/pusher';

import { ComponentsModule } from './components';
import { SharedModule } from './shared';

import { $gbSentry } from 'crowdcomms-js/lib/galabid/errors/classes/gb-sentry.class.js';

/*
 *  Set up Sentry if it is enabled for this build
 */

let dependencies = [
    angularUiRouter,
    angularMaterial,
    angularMessages,
    CacheModule,
    GalabidUrlModule,
    PusherModule,
    ComponentsModule,
    SharedModule,
];

try {
    let reportingEnabled = process.env.ERROR_REPORTING_ENABLED;
    let sentryDsn = process.env.SENTRY_DSN;

    if (reportingEnabled && sentryDsn) {
        $gbSentry.init({
            dsn: sentryDsn,
        });

        dependencies.push('ngSentry');
    } else {
        console.warn('Error reporting disabled! No errors will be reported to Sentry.', reportingEnabled, sentryDsn);
    }
} catch (error) {
    console.error(error);
}

/*
 *  End Sentry setup, continue with module initialization
 */

export const GalabidPresenterModule = angular.module('galabid-presenter', dependencies).name;
